module.exports = __webpack_public_path__ + "static/media/Galdisa_Ficha_MaizQuesoCheddar.85ab446b.pdf";